import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get brand
export const getBrand = createAsyncThunk("brand/getBrand", async (params, { rejectWithValue }) => {
  try {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    const { data } = await API.getBrand({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all brand
export const getAllBrand = createAsyncThunk("brand/getAllBrand", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllBrand();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("brand/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("brand/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("brand/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageBrand({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create brand
export const createBrand = createAsyncThunk("brand/createBrand", async (data, { rejectWithValue }) => {
  const { name, isActive } = data;
  try {
    const body = JSON.stringify({ name, isActive });
    const { data } = await API.createBrand(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateBrand = createAsyncThunk("brand/updateBrand", async (data, { rejectWithValue }) => {
  const { id, values } = data;
  const { name, isActive } = values;
  try {
    const body = JSON.stringify({ name, isActive });
    const { data } = await API.updateBrand(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("brand/handleSearch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getBrand({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
